export default "__VITE_ASSET__73cff259__"